import { Box, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';
import { WaveVideoBackground } from '~/components/wave-video-background';

export type WaveHeroSectionProps = {
  title: string;
  description?: string | null;
};

export function WaveHeroSection({ title, description }: WaveHeroSectionProps) {
  return (
    <Box
      as='section'
      position='relative'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <WaveVideoBackground />
      <ContentContainer
        color='white'
        display='flex'
        flexDirection='column'
        gap={4}
        position='relative'
        textAlign='center'
      >
        <Heading
          as='h1'
          size={{
            base: 'marketing-3xl',
            md: 'marketing-5xl',
          }}
        >
          {title}
        </Heading>
        {!!description && (
          <Box margin='0 auto' maxWidth='700px'>
            <Markdown markdownText={description} />
          </Box>
        )}
      </ContentContainer>
    </Box>
  );
}
